import { Component, computed, effect, input, signal } from '@angular/core';
import { PatientBehaviorAntecedentModel } from '../../../core/api/models';
import {
  StaffApiService,
  SupervisorApiService,
} from '../../../core/api/services';
import { AlertService } from '../../../shared/services/alert.service';
import { SupervisorHelperService } from '../../supervisor.helper.service';
import { Utils } from '../../../core/utils';
import { SelectItemGroup } from 'primeng/api';
import { Router } from '@angular/router';
@Component({
  selector: 'app-antecedents',
  templateUrl: './antecedents.component.html',
  standalone: false,
})
export class AntecedentsComponent {
  patientID = input.required<number>();

  antecedents = signal<PatientBehaviorAntecedentModel[]>([]);

  loadingAntecedents = signal<boolean>(false);
  showAddAntecedent = this.supervisorHelperService.showAddAntecedent;

  searchKeyword = signal<string | null>(null);
  includeDeleted = signal<boolean>(false);

  filteredAntecedents = computed(() => {
    let filteredAntecedents = this.antecedents();
    // use keyword from search bar for the first filter
    if (this.searchKeyword() != null && this.searchKeyword() != '') {
      filteredAntecedents = filteredAntecedents.filter((antecedent) =>
        antecedent.PatientBehaviorAntecedent?.toLowerCase().includes(
          this.searchKeyword()!.toLowerCase()
        )
      );
    }
    if (!this.includeDeleted()) {
      filteredAntecedents = filteredAntecedents.filter(
        (antecedent) => !antecedent.IsDeleted
      );
    }
    return filteredAntecedents;
  });

  constructor(
    private staffApiService: StaffApiService,
    private supervisorApiService: SupervisorApiService,
    private alertService: AlertService,
    protected supervisorHelperService: SupervisorHelperService,
    private router: Router
  ) {
    effect(
      () => {
        console.log(
          'update signal triggered: ',
          this.supervisorHelperService.updateSignal()
        );
        this.loadData();
      },
      { allowSignalWrites: true }
    );
  }

  ngOnInit(): void {
    console.log('RemindersComponent ngOnInit');
    if (this.patientID()) {
      this.loadData();
    } else {
      this.router.navigate(['/select-patient']);
    }
  }

  loadData() {
    this.loadingAntecedents.set(true);
    this.staffApiService
      .GetPatientBehaviorAntecedents({ patientID: Number(this.patientID()) })
      .subscribe(
        (antecedents) => {
          this.loadingAntecedents.set(false);
          this.antecedents.set(antecedents);
        },
        (err) => {
          this.loadingAntecedents.set(false);
          this.alertService.error(Utils.getErrorMessageFromErrorResponse(err));
        }
      );
  }

  addAntecedentButtonClicked() {
    console.log('addAntecedentButtonClicked');
    this.supervisorHelperService.addAntecedentButtonClicked(null);
  }

  onCloseAddAntecedent(withChanges: boolean = false) {
    this.supervisorHelperService.onCloseAddAntecedent(withChanges);
  }

  getFromBIPButtonClicked() {
    console.log('getFromBIPButtonClicked');
    this.supervisorApiService
      .ImportAntecedentsFromBIP({ patientID: Number(this.patientID()) })
      .subscribe(
        (response) => {
          console.log('ImportAntecedentsFromBIP response: ', response);
          this.loadData();
        },
        (err) => {
          this.alertService.error(Utils.getErrorMessageFromErrorResponse(err));
        }
      );
  }

  clearSearch() {
    this.searchKeyword.set(null);
    this.includeDeleted.set(false);
  }

  toggleIncludeDeleted() {
    this.includeDeleted.set(!this.includeDeleted());
  }
}
